type ApiUrlFunction = (...args: any[]) => string;

type ApiUrlConfig = {
  crawlers: (id?: string | number) => string;
  crawler_crawl_completed: (id: string | number) => string;
  scripts: (id?: string | number) => string;
  scripts_is_user_same: (id: string | number) => string;
  datasources: (id?: string | number) => string;
  flowUpdateDatasources: (id: string | number) => string;
  authDatasources: (id: string | number) => string;
  flowdatasources: (id?: string | number) => string;
  generated_datasources: () => string;
  move_generated_datasources: () => string;
  api_generated_datasources: () => string;
  api_move_generated_datasources: () => string;
  components: (id?: string | number) => string;
  component_config: (id?: string | number) => string;
  git_flow_set_active_branch: () => string;
  git_flow_push: () => string;
  git_flow_revert: () => string;
  git_flow_pull: () => string;
  git_flow_merge: () => string;
  git_flow_fetch_version: () => string;
  git_flow_fetch_draft_version: (userId: string | number, branch: string) => string;
  git_flow_log: (branch: string) => string;
  git_flow_last_pull: (userId: string | number, branch: string) => string;
  virtualization_stub_fetch_all: (projectId: string | number, userId: string | number) => string;
  virtualization_stub_fetch_by_id: (id: string | number) => string;
  virtualization_stub_create: () => string;
  virtualization_stub_update: (id: string | number) => string;
  virtualization_stub_delete: (id: string | number) => string;
  virtualization_faults_fetch_all: (projectId: string | number, userId: string | number) => string;
  virtualization_faults_fetch_by_id: (id: string | number) => string;
  virtualization_faults_create: () => string;
  virtualization_faults_update: (id: string | number) => string;
  virtualization_faults_delete: (id: string | number) => string;
  virtualization_scenario_fetch_all: (projectId: string | number, userId: string | number) => string;
  virtualization_scenario_fetch_by_id: (id: string | number) => string;
  virtualization_scenario_create: () => string;
  virtualization_scenario_update: (id: string | number) => string;
  virtualization_scenario_delete: (id: string | number) => string;
  virtualization_template_fetch_all: (projectId: string | number, userId: string | number) => string;
  virtualization_template_fetch_by_id: (id: string | number) => string;
  virtualization_template_create: () => string;
  virtualization_template_update: (id: string | number) => string;
  virtualization_template_delete: (id: string | number) => string;
  virtualization_transformer_fetch_all: (projectId: string | number, userId: string | number) => string;
  virtualization_transformer_fetch_by_id: (id: string | number) => string;
  virtualization_transformer_create: () => string;
  virtualization_transformer_update: (id: string | number) => string;
  virtualization_transformer_delete: (id: string | number) => string;
  virtualization_journal_fetch_all: (projectId: string | number, userId: string | number) => string;
  virtualization_journal_fetch_by_id: (id: string | number) => string;
  virtualization_journal_create: () => string;
  virtualization_journal_update: (id: string | number) => string;
  virtualization_journal_delete: (id: string | number) => string;
  virtualization_https_toggle: (enabled: boolean | string) => string;
  virtualization_https_fetch_one: () => string;
  search: string;
  cost_saving_web_test_lab_search: string;
  cost_saving_setting: string;
  cost_saving_get_project_test_cases: (id: string | number) => string;
  get_cost_saving_setting: (id: string | number) => string;
  apis: (id?: string | number) => string;
  api_config: (id?: string | number) => string;
  api_update_config: (id: string | number) => string;
  apis_by_groupid: (id?: string | number) => string;
  components_add_remove_datasource: (componentID: string | number, datasourceID?: string | number) => string;
  components_add_remove_script: (componentID: string | number, scriptID?: string | number) => string;
  api_bulk_insert: () => string;
  // Swagger/OpenAPI flow import: preview what a spec implies, then
  // create only the flows that were ticked.
  api_flow_import_preview: (groupId: string | number) => string;
  api_flow_import_create: (groupId: string | number) => string;
  // Configuration file -> variables, one set per environment.
  config_import_preview: (groupId: string | number) => string;
  config_import: (groupId: string | number) => string;
  api_add_activity: (id: string | number) => string;
  api_update_response_activity: (id: string | number) => string;
  api_save_execution_results: (id: string | number) => string;
  api_get_execution_results: (id: string | number) => string;
  api_write_back_results: (id: string | number) => string;
  api_export_execution_csv: (id: string | number) => string;
  api_copy_logic: (id: string | number) => string;
  // GraphQL API endpoints
  graphql_api: (id: string | number) => string;
  graphql_api_group: (groupId: string | number) => string;
  graphql_api_create: () => string;
  graphql_api_delete: (id: string | number) => string;
  graphql_api_activity: (id: string | number) => string;
  graphql_api_endpoint: (id: string | number) => string;
  graphql_api_config: (id: string | number) => string;
  graphql_api_response: (id: string | number) => string;
  graphql_api_schema: (id: string | number) => string;
  graphql_api_execution_results: (id: string | number) => string;
  graphql_api_write_back: (id: string | number) => string;
  graphql_api_csv: (id: string | number) => string;
  graphql_api_import_sdl: (id: string | number) => string;
  graphql_api_introspect: (id: string | number) => string;
  graphql_api_parse_schema: () => string;
  graphql_api_ai_generate: (id: string | number) => string;
  graphql_api_ai_refine_validations: (id: string | number) => string;
  graphql_api_bulk_insert: () => string;
  graphql_api_export: (id: string | number) => string;
  api_update_response_order: (id: string | number) => string;
  api_delete_logic: (id: string | number, index: number) => string;
  connection_delete_logic: (id: string | number, index: number) => string;
  api_upload_certificate: (id: string | number) => string;
  api_delete_certificate: (id: string | number) => string;
  api_validate_response: (id: string | number) => string;
  connection_validate_response: (id: string | number) => string;
  delete_multiple_logic: (id: string | number) => string;
  connection_delete_multiple_logic: (id: string | number) => string;
  connection_swap_resultset: (id: string | number) => string;
  handle_imports: (id: string | number) => string;
  api_swap_response: (id: string | number) => string;
  api_curl_execute: () => string;
  components_copy_activity: () => string;
  components_add_activity: (id: string | number) => string;
  components_add_loop_element: (id: string | number) => string;
  components_update_test_description: (id: string | number) => string;
  components_except_loop_element: (id: string | number) => string;
  components_remove_activity: (id: string | number) => string;
  components_remove_group_activity: (id: string | number) => string;
  components_remove_child_activity: (id: string | number) => string;
  components_update_activity: (id: string | number) => string;
  components_update_child_activity: (id: string | number) => string;
  components_update_iframe_child_activity: (id: string | number) => string;
  components_update_window_child_activity: (id: string | number) => string;
  components_update_activity_breakpoint_status: (id: string | number) => string;
  components_create_img: (id: string | number) => string;
  components_upload_activity_image: (id: string | number) => string;
  components_update_group_activity: (id: string | number) => string;
  components_is_user_same: (id: string | number) => string;
  components_flows_using: (id: string | number) => string;
  flows: (id?: string | number) => string;
  flow_export_to_tcm: (id: string | number, projectKey: string) => string;
  flows_remove_group_activity: (id: string | number) => string;
  flows_update_component_order: (id: string | number) => string;
  flow_group_flow_order: (id: string | number) => string;
  connections: (id?: string | number) => string;
  updateConnectionContent: (id: string | number) => string;
  projectComponents: (projectId: string | number) => string;
  projectusers: (id?: string | number) => string;
  projectusers_add_variable: (id: string | number) => string;
  project_add_runtime_variable: (id: string | number) => string;
  projectusers_is_user_same: (id: string | number) => string;
  projectusers_update_variable: (id: string | number, index: number) => string;
  projectusers_remove_variable: (id: string | number, index: number) => string;
  projectusers_add_with_variables: () => string;
  project_variables: (id: string | number) => string;
  connection_is_user_same: (id: string | number) => string;
  datasheet: (id: string | number) => string;
  copyDatasheet: (id: string | number) => string;
  componentsByGroup: (id: string | number, componentId: string | number) => string;
  projects: (id?: string | number) => string;
  projectDetails: () => string;
  projectsByProjectId: (id: string | number) => string;
  projectsBasicDetail: (id: string | number) => string;
  projectList: (id?: string | number) => string;
  projectListLazy: () => string;
  projectByIdAndContentType: (id: string | number, contentType: string) => string;
  projectByIdAndComponentId: (id: string | number, componentId: string | number) => string;
  projectUserNameList: (id: string | number) => string;
  removeRuntimeVariable: (id: string | number) => string;
  flowNames: (id: string | number) => string;
  apiFlowNames: (id: string | number) => string;
  flowGroups: (id?: string | number) => string;
  flowResult: (flowId: string | number) => string;
  copyFlow: (id: string | number) => string;
  reportFlow: (id: string | number) => string;
  test_generate: () => string;
  flow_component_activities_ids: (flowId: string | number, componentId: string | number) => string;
  flow_component_checked: (flowId: string | number, componentId: string | number) => string;
  flow_check_component_conflict: (flowId: string | number, componentId: string | number) => string;
  flow_update_active_component: (id: string | number) => string;
  flow_is_user_same: (id: string | number) => string;
  copyUservariable: (id: string | number) => string;
  copyScript: (id: string | number) => string;
  copyApi: (id: string | number) => string;
  copyComponent: (id: string | number) => string;
  copyConnection: (id: string | number) => string;
  swapActivity: (id: string | number) => string;
  swapApiActivity: (id: string | number) => string;
  remove_Datasource_column: (id: string | number) => string;
  encrypt_Datasource_column: (datasourceId: string | number, columnId: string | number, type: string) => string;
  userVariable_Datasource_column: (datasourceId: string | number, columnId: string | number) => string;
  userVariable_FlowDatasource_column: (datasourceId: string | number, columnId: string | number) => string;
  encrypt_flowDatasource_column: (datasourceId: string | number, columnId: string | number) => string;
  decrypt_flowDatasource_column: (datasourceId: string | number, columnId: string | number) => string;
  remove_flowdatasource_column: (id: string | number) => string;
  add_flowdatasource_column: (id: string | number) => string;
  add_connectiondatasource_column: (id: string | number) => string;
  help_structure: () => string;
  api_header_save: () => string;
  api_header_delete: (headerId: string | number) => string;
  api_header_usage: (headerId: string | number) => string;
  remove_header_property: () => string;
  api_count_by_headerId: (headerId: string | number) => string;
  api_get_header: (id: string | number) => string;
  api_get_header_api: (projectId: string | number, apiId: string | number) => string;
  get_active_id_by_componentId: (componentId: string | number) => string;
  add_jiratestcase: () => string;
  update_jiratestcase: () => string;
  zephyr_jira_project: () => string;
  zephyr_jira_issue: () => string;
  zephyr_jira_version: () => string;
  zephyr_jira_component: () => string;
  zephyr_jira_environment: () => string;
  zephyr_jira_folder: () => string;
  zephyr_jira_cycle: () => string;
  azure_get_project: () => string;
  AESencrypt_Datasource_column: (datasourceId: string | number, columnId: string | number, type: string) => string;
  fetchMetrics: () => string;
  fetchMetricsUser: () => string;
  fetchMonthlyMetrics: () => string;
  fetchMonthlyMetricsByRange: () => string;
  fetchMonthlyYears: () => string;
  fetchMonthlyMonths: () => string;
  aggregateMonthlyMetrics: () => string;
  fetchQuarterlyMetrics: () => string;
  fetchQuarterlyMetricsByRange: () => string;
  fetchQuarterlyYears: () => string;
  fetchQuarterlyQuarters: () => string;
  aggregateQuarterlyMetrics: () => string;
  fetchYearlyMetrics: () => string;
  fetchYearlyMetricsByRange: () => string;
  fetchYearlyYears: () => string;
  aggregateYearlyMetrics: () => string;
  backfillMetrics: (projectId: string) => string;
  fetchExecutionReports: () => string;
  fetchExecutionReport: (id: string) => string;
  fetchExecutionReportTrends: () => string;
  fetchExecutionReportProjects: () => string;
  fetchExecutionReportTesters: () => string;
  fetchExecutionReportModes: () => string;
  fetchExecutionReportHtml: (id: string) => string;
  fetchExecutionReportJUnitXml: (id: string) => string;
  perfBudgetsList: (projectId: string) => string;
  perfBudgetsCreate: () => string;
  perfBudgetsUpdate: (id: string) => string;
  perfBudgetsDelete: (id: string) => string;
  perfFlakiness: (projectId: string, days?: number) => string;
  perfTriage: () => string;
  executiveReportMonthly: (projectId: string, year: number, month: number) => string;
  executiveReportRange: (projectId: string, startDate: string, endDate: string) => string;
  lighthouseStatus: () => string;
  lighthouseAudit: () => string;
  lighthouseList: (projectId: string, url?: string, limit?: number) => string;
  lighthouseById: (id: string) => string;
  lighthouseRaw: (id: string) => string;
  agileArtifactsCreate: () => string;
  agileArtifactsUpdate: (id: string | number) => string;
  workFlowCreate: () => string;
  workFlowUpdate: (id: string | number) => string;
  api_col_update: (id: string | number) => string;
};

export const apiUrlConfig: ApiUrlConfig = {
  crawlers: id => (id ? `/crawlers/${id}` : "/crawlers"),
  crawler_crawl_completed: id => `/crawlers/${id}/crawl-completed`,
  scripts: id => (id ? `/scripts/${id}` : "/scripts"),
  scripts_is_user_same: id => `/scripts/${id}/hasAccess`,
  datasources: id => (id ? `/datasources/${id}` : "/datasources"),
  flowUpdateDatasources: id => `/datasources/${id}/flowupdatedatasources`,

  authDatasources: id => `/datasources/${id}/auth`,
  flowdatasources: id => (id ? `/flowdatasources/${id}` : "/flowdatasources"),

  generated_datasources: () => `/generated_datasources`,
  move_generated_datasources: () => `/generated_datasources/moveGeneratedDatasource`,
  api_generated_datasources: () => `/api_generated_datasources`,
  api_move_generated_datasources: () => `/api_generated_datasources/moveGeneratedDatasource`,
  components: id => (id ? `/components/${id}` : "/components"),
  component_config: id => (id ? `/components/config/${id}` : "/components"),

  git_flow_set_active_branch: () => `/api/gitflow/activeBranch/set`,
  git_flow_push: () => `/api/gitflow/push`,
  git_flow_revert: () => `/api/gitflow/revert`,
  git_flow_pull: () => `/api/gitflow/pull`,
  git_flow_merge: () => `/api/gitflow/merge`,
  git_flow_fetch_version: () => `/api/gitflow/fetch/version`,
  git_flow_fetch_draft_version: (userId, branch) => `/api/gitflow/draft/version?userId=${userId}&branch=${branch}`,
  git_flow_log: branch => `/api/gitflow/log?branch=${branch}`,
  git_flow_last_pull: (userId, branch) => `/api/gitflow/last-pull?userId=${userId}&branch=${branch}`,

  virtualization_stub_fetch_all: (projectId, userId) =>
    `/api/virtualization/stubs?projectId=${projectId}&userId=${userId}`,
  virtualization_stub_fetch_by_id: id => `/api/virtualization/stubs/${id}`,
  virtualization_stub_create: () => `/api/virtualization/stubs`,
  virtualization_stub_update: id => `/api/virtualization/stubs/${id}`,
  virtualization_stub_delete: id => `/api/virtualization/stubs/${id}`,

  virtualization_faults_fetch_all: (projectId, userId) =>
    `/api/virtualization/faults?projectId=${projectId}&userId=${userId}`,
  virtualization_faults_fetch_by_id: id => `/api/virtualization/faults/${id}`,
  virtualization_faults_create: () => `/api/virtualization/faults`,
  virtualization_faults_update: id => `/api/virtualization/faults/${id}`,
  virtualization_faults_delete: id => `/api/virtualization/faults/${id}`,

  virtualization_scenario_fetch_all: (projectId, userId) =>
    `/api/virtualization/scenarios?projectId=${projectId}&userId=${userId}`,
  virtualization_scenario_fetch_by_id: id => `/api/virtualization/scenarios/${id}`,
  virtualization_scenario_create: () => `/api/virtualization/scenarios`,
  virtualization_scenario_update: id => `/api/virtualization/scenarios/${id}`,
  virtualization_scenario_delete: id => `/api/virtualization/scenarios/${id}`,

  virtualization_template_fetch_all: (projectId, userId) =>
    `/api/virtualization/templates?projectId=${projectId}&userId=${userId}`,
  virtualization_template_fetch_by_id: id => `/api/virtualization/templates/${id}`,
  virtualization_template_create: () => `/api/virtualization/templates`,
  virtualization_template_update: id => `/api/virtualization/templates/${id}`,
  virtualization_template_delete: id => `/api/virtualization/templates/${id}`,

  virtualization_transformer_fetch_all: (projectId, userId) =>
    `/api/virtualization/transformers?projectId=${projectId}&userId=${userId}`,
  virtualization_transformer_fetch_by_id: id => `/api/virtualization/transformers/${id}`,
  virtualization_transformer_create: () => `/api/virtualization/transformers`,
  virtualization_transformer_update: id => `/api/virtualization/transformers/${id}`,
  virtualization_transformer_delete: id => `/api/virtualization/transformers/${id}`,

  virtualization_journal_fetch_all: (projectId, userId) =>
    `/api/virtualization/journals?projectId=${projectId}&userId=${userId}`,
  virtualization_journal_fetch_by_id: id => `/api/virtualization/journals/${id}`,
  virtualization_journal_create: () => `/api/virtualization/journals`,
  virtualization_journal_update: id => `/api/virtualization/journals/${id}`,
  virtualization_journal_delete: id => `/api/virtualization/journals/${id}`,

  virtualization_https_toggle: enabled => `/api/virtualization/https/toggle?enabled=${enabled}`,
  virtualization_https_fetch_one: () => `/api/virtualization/https`,

  search: "/api/testReport/search",
  cost_saving_web_test_lab_search: "/api/costSaving/webTestLab/search",
  cost_saving_setting: "/api/costSaving/setting",
  cost_saving_get_project_test_cases: id => `/api/costSaving/getProjectTestCases/${id}`,
  get_cost_saving_setting: id => `/api/costSaving/setting/${id}`,

  apis: id => (id ? `/api/${id}` : "/api"),
  api_config: id => (id ? `/api/config/${id}` : "/api"),
  api_update_config: id => `/api/${id}/config`,
  apis_by_groupid: id => (id ? `/api/group/${id}` : "/api"),
  // GraphQL API endpoints
  graphql_api: id => `/graphql-api/${id}`,
  graphql_api_group: groupId => `/graphql-api/group/${groupId}`,
  graphql_api_create: () => `/graphql-api`,
  graphql_api_delete: id => `/graphql-api/${id}`,
  graphql_api_activity: id => `/graphql-api/${id}/activity`,
  graphql_api_endpoint: id => `/graphql-api/${id}/endpoint`,
  graphql_api_config: id => `/graphql-api/${id}/config`,
  graphql_api_response: id => `/graphql-api/${id}/response`,
  graphql_api_schema: id => `/graphql-api/${id}/schema`,
  graphql_api_execution_results: id => `/graphql-api/${id}/execution-results`,
  graphql_api_write_back: id => `/graphql-api/${id}/write-back-results`,
  graphql_api_csv: id => `/graphql-api/${id}/execution-results/csv`,
  graphql_api_import_sdl: id => `/graphql-api/${id}/schema/import-sdl`,
  graphql_api_introspect: id => `/graphql-api/${id}/schema/introspect`,
  graphql_api_parse_schema: () => `/graphql-api/schema/parse`,
  graphql_api_ai_generate: id => `/graphql-api/${id}/ai/generate-test-data`,
  graphql_api_ai_refine_validations: id => `/graphql-api/${id}/ai/refine-validations`,
  graphql_api_bulk_insert: () => `/graphql-api/bulk`,
  graphql_api_export: id => `/graphql-api/${id}/export`,
  components_add_remove_datasource: (componentID, datasourceID) =>
    datasourceID
      ? `/components/${componentID}/addDatasource?datasourceId=${datasourceID}`
      : `/components/${componentID}/addDatasource`,
  components_add_remove_script: (componentID, scriptID) =>
    scriptID ? `/components/${componentID}/addScript?scriptId=${scriptID}` : `/components/${componentID}/addScript`,
  api_bulk_insert: () => "/api/bulk",
  api_flow_import_preview: groupId => `/api/flow-import/${groupId}/preview`,
  api_flow_import_create: groupId => `/api/flow-import/${groupId}/create`,
  config_import_preview: groupId => `/config-import/${groupId}/preview`,
  config_import: groupId => `/config-import/${groupId}/import`,
  api_add_activity: id => `/api/${id}/addActivity`,
  api_update_response_activity: id => `/api/${id}/updateActivityExeResponse`,
  api_save_execution_results: id => `/api/${id}/execution-results`,
  api_get_execution_results: id => `/api/${id}/execution-results`,
  api_write_back_results: id => `/api/${id}/write-back-results`,
  api_export_execution_csv: id => `/api/${id}/execution-results/csv`,
  api_copy_logic: id => `/api/${id}/copyLogic`,
  api_update_response_order: id => `/api/${id}/updateResponseOrder`,
  api_delete_logic: (id, index) => `/api/${id}/deleteLogic/${index}`,
  connection_delete_logic: (id, index) => `/connections/${id}/deleteLogic/${index}`,
  api_upload_certificate: id => `/api/${id}/uploadCertificate`,
  api_delete_certificate: id => `/api/${id}/deleteCertificate`,
  api_validate_response: id => `/api/${id}/validateResponse`,
  connection_validate_response: id => `/connections/${id}/validateResponse`,
  delete_multiple_logic: id => `/api/${id}/deleteMultipleLogic`,
  connection_delete_multiple_logic: id => `/connections/${id}/deleteMultipleLogic`,
  connection_swap_resultset: id => `/connections/${id}/swapResultset`,
  handle_imports: id => `/api/${id}/handleImports`,
  api_swap_response: id => `/api/${id}/swapResponse`,
  api_curl_execute: () => `/api/curl`,
  components_copy_activity: () => `/components/copyActivity`,
  components_add_activity: id => `/components/${id}/addActivity`,
  components_add_loop_element: id => `/components/${id}/addLoopCondition`,
  components_update_test_description: id => `/components/${id}/updateTestDescription`,
  components_except_loop_element: id => `/components/${id}/addExceptLoopCondition`,
  components_remove_activity: id => `/components/${id}/removeActivity`,
  components_remove_group_activity: id => `/components/${id}/removeGroup`,
  components_remove_child_activity: id => `/components/${id}/removeChildActivity`,
  components_update_activity: id => `/components/${id}/updateActivity`,
  components_update_child_activity: id => `/components/${id}/updateChildActivity`,
  components_update_iframe_child_activity: id => `/components/${id}/updateIframeChildActivity`,
  components_update_window_child_activity: id => `/components/${id}/updateWindowChildActivity`,
  components_update_activity_breakpoint_status: id => `/components/${id}/updateActvityBreakPointStatus`,
  components_create_img: id => `/components/${id}/getImgUrl`,
  components_upload_activity_image: id => `/components/${id}/activities/uploadImage`,
  components_update_group_activity: id => `/components/${id}/updateGroup`,
  components_is_user_same: id => `/components/${id}/hasAccess`,
  components_flows_using: id => `/components/${id}/flowsUsingComponent`,
  flows: id => (id ? `/flows/${id}` : "/flows"),
  flow_export_to_tcm: (id, projectKey) =>
    `/flows/${id}/export-to-tcm?projectKey=${encodeURIComponent(projectKey)}`,
  flows_remove_group_activity: id => `/flows/${id}/removeGroup`,
  flows_update_component_order: id => `/flows/${id}/updateOrder`,
  flow_group_flow_order: id => `/flow-groups/${id}/updateFlowOrder`,
  connections: id => (id ? `/connections/${id}` : "/connections"),
  updateConnectionContent: id => `/connections/${id}/updateContent`,
  projectComponents: projectId => `/projects/components?projectId=${projectId}`,

  projectusers: id => (id ? `/uservariables/${id}` : "/uservariables"),
  projectusers_add_variable: id => `/uservariables/${id}/addVariable`,
  project_add_runtime_variable: id => `/uservariables/${id}/addRuntimeVariable`,
  projectusers_is_user_same: id => `/uservariables/${id}/hasAccess`,
  projectusers_update_variable: (id, index) => `/uservariables/${id}/updateVariable?index=${index}`,
  projectusers_remove_variable: (id, index) => `/uservariables/${id}/removeVariable?index=${index}`,
  projectusers_add_with_variables: () => "/uservariables/withVariables",
  project_variables: id => `/projects/${id}/variable`,

  connection_is_user_same: id => `/connections/${id}/hasAccess`,
  datasheet: id => `/connections/${id}/datasheet`,
  copyDatasheet: id => `/connections/${id}/copyDatasheet`,
  componentsByGroup: (id, componentId) => `/components/${id}/${componentId}/componentsByGroup`,
  projects: id => (id ? `/projects/${id}` : `/projects`),
  projectDetails: () => `/projects/details`,
  projectsByProjectId: id => `/projects?projectId=${id}`,
  projectsBasicDetail: id => `/projects/basic/${id}`,
  projectList: id => (id ? `/projects/list/${id}` : `/projects/list`),
  projectListLazy: () => `/projects/list/lazy`,
  projectByIdAndContentType: (id, contentType) => `/projects/${id}/${contentType}`,
  projectByIdAndComponentId: (id, componentId) => `/projects/${id}/component/${componentId}`,
  projectUserNameList: id => `/projects/userNameList/${id}`,
  projectConfig: id => `/projects/${id}/config`,

  removeRuntimeVariable: id => `/projects/${id}/removeRuntimeVariable`,
  flowNames: id => `/flows/${id}/flowNames`,
  apiFlowNames: id => `/flows/${id}/apiFlowNames`,
  flowGroups: id => (id ? `/flow-groups/${id}` : "/flow-groups"),
  flowResult: flowId => `/flow-report/${flowId}/latest`,
  copyFlow: id => `/flows/${id}/copyFlow`,
  reportFlow: id => `/report`,
  test_generate: () => `/datasources/testGenerate`,
  flow_component_activities_ids: (flowId, componentId) => `/flows/${flowId}/${componentId}/handleActivityId`,
  flow_component_checked: (flowId, componentId) => `/flows/${flowId}/${componentId}/checked`,
  flow_check_component_conflict: (flowId, componentId) => `/flows/${flowId}/checkComponentConflict/${componentId}`,
  flow_update_active_component: id => `/flows/${id}/updateActiveComponent`,
  flow_is_user_same: id => `/flows/${id}/hasAccess`,
  copyUservariable: id => `/uservariables/${id}/copyUservariable`,
  copyScript: id => `/scripts/${id}/copyScript`,
  copyApi: id => `/api/${id}/copyApi`,
  copyComponent: id => `/components/${id}/copyComponent`,
  copyConnection: id => `/connections/${id}/copyConnection`,
  swapActivity: id => `/components/${id}/swapActivity`,
  swapApiActivity: id => `/api/${id}/swapActivity`,
  remove_Datasource_column: id => `/datasources/${id}/removeColumn`,
  encrypt_Datasource_column: (datasourceId, columnId, type) => `/datasources/${datasourceId}/${columnId}/${type}Column`,
  userVariable_Datasource_column: (datasourceId, columnId) =>
    `/datasources/${datasourceId}/${columnId}/updateUserVariable`,
  userVariable_FlowDatasource_column: (datasourceId, columnId) =>
    `/flowdatasources/${datasourceId}/${columnId}/updateUserVariable`,
  encrypt_flowDatasource_column: (datasourceId, columnId) =>
    `/flowdatasources/${datasourceId}/${columnId}/encryptColumn`,
  decrypt_flowDatasource_column: (datasourceId, columnId) =>
    `/flowdatasources/${datasourceId}/${columnId}/decryptColumn`,

  remove_flowdatasource_column: id => `/flowdatasources/${id}/removeColumn`,
  add_flowdatasource_column: id => `/flowdatasources/${id}/addColumn`,

  add_connectiondatasource_column: id => `/connectiondatasources/${id}/addColumn`,

  help_structure: () => `/help`,
  api_header_save: () => `/api/header`,
  api_header_delete: headerId => `/api/header/${headerId}`,
  api_header_usage: headerId => `/api/header/usage/${headerId}`,
  remove_header_property: () => `/api/removeHeaderProperty`,
  api_count_by_headerId: headerId => `/api/count/${headerId}`,
  api_get_header: id => `/api/header/${id}`,
  api_get_header_api: (projectId, apiId) => `/api/header/${projectId}/${apiId}`,
  get_active_id_by_componentId: componentId => `/datasources/datasheet/activity/${componentId}`,
  add_jiratestcase: () => `/api/jira/jiratestcase/add`,
  update_jiratestcase: () => `/api/jira/jiratestcase/update`,
  zephyr_jira_project: () => `/api/jira/project/all`,
  zephyr_jira_issue: () => `/api/jira/issuetype/all`,
  zephyr_jira_version: () => `/api/jira/project/version/get`,
  zephyr_jira_component: () => `/api/jira/component/all`,
  zephyr_jira_environment: () => `/api/jira/environment/all`,
  zephyr_jira_folder: () => `/api/jira/folder/all`,
  zephyr_jira_cycle: () => `/api/jira/testcycle/all`,
  azure_get_project: () => `/api/azure/getproject`,
  AESencrypt_Datasource_column: (datasourceId, columnId, type) =>
    `/datasources/${datasourceId}/${columnId}/${type}Column/aes`,

  fetchMetrics: () => `/api/metrics`,
  fetchMetricsUser: () => `/api/metrics/users`,
  fetchMonthlyMetrics: () => `/api/metrics/monthly`,
  fetchMonthlyMetricsByRange: () => `/api/metrics/monthly/range`,
  fetchMonthlyYears: () => `/api/metrics/monthly/years`,
  fetchMonthlyMonths: () => `/api/metrics/monthly/months`,
  aggregateMonthlyMetrics: () => `/api/metrics/monthly/aggregate`,
  fetchQuarterlyMetrics: () => `/api/metrics/quarterly`,
  fetchQuarterlyMetricsByRange: () => `/api/metrics/quarterly/range`,
  fetchQuarterlyYears: () => `/api/metrics/quarterly/years`,
  fetchQuarterlyQuarters: () => `/api/metrics/quarterly/quarters`,
  aggregateQuarterlyMetrics: () => `/api/metrics/quarterly/aggregate`,
  fetchYearlyMetrics: () => `/api/metrics/yearly`,
  fetchYearlyMetricsByRange: () => `/api/metrics/yearly/range`,
  fetchYearlyYears: () => `/api/metrics/yearly/years`,
  aggregateYearlyMetrics: () => `/api/metrics/yearly/aggregate`,
  backfillMetrics: (projectId) => `/api/metrics/backfill?projectId=${projectId}`,

  fetchExecutionReports: () => `/api/execution-reports`,
  fetchExecutionReport: (id) => `/api/execution-reports/${id}`,
  fetchExecutionReportTrends: () => `/api/execution-reports/trends`,
  fetchExecutionReportProjects: () => `/api/execution-reports/projects`,
  fetchExecutionReportTesters: () => `/api/execution-reports/testers`,
  fetchExecutionReportModes: () => `/api/execution-reports/modes`,
  fetchExecutionReportHtml: (id) => `/api/execution-reports/${id}/html-report`,
  // Phase C2 — JUnit XML export for CI systems.
  fetchExecutionReportJUnitXml: (id) => `/api/execution-reports/${id}/junit.xml`,

  // Phase B — perf-budget CRUD. Backend at PerfBudgetController.
  // List is project-scoped via query param; single-item ops via path id.
  perfBudgetsList: (projectId) => `/api/perf-budgets?projectId=${encodeURIComponent(projectId)}`,
  perfBudgetsCreate: () => `/api/perf-budgets`,
  perfBudgetsUpdate: (id) => `/api/perf-budgets/${id}`,
  perfBudgetsDelete: (id) => `/api/perf-budgets/${id}`,

  // Phase B7 — read-only aggregation across the last N days of reports.
  perfFlakiness: (projectId, days) =>
    `/api/perf-flakiness?projectId=${encodeURIComponent(projectId)}&days=${days || 30}`,

  // Phase C5 — AI page-load-perf triage. POST body: {executionReportId, url}.
  perfTriage: () => `/api/perf-triage`,

  // Phase C4 — Executive PDF export. Monthly (year+month) or range.
  executiveReportMonthly: (projectId, year, month) =>
    `/api/executive-report/monthly.pdf?projectId=${encodeURIComponent(projectId)}&year=${year}&month=${month}`,
  executiveReportRange: (projectId, startDate, endDate) =>
    `/api/executive-report/range.pdf?projectId=${encodeURIComponent(projectId)}` +
    `&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,

  // Phase C1 — Lighthouse mode. Sidecar-backed audits via the Java backend.
  lighthouseStatus: () => `/api/lighthouse/status`,
  lighthouseAudit: () => `/api/lighthouse/audit`,
  lighthouseList: (projectId, url, limit) => {
    const parts = [`projectId=${encodeURIComponent(projectId)}`];
    if (url) parts.push(`url=${encodeURIComponent(url)}`);
    if (limit) parts.push(`limit=${limit}`);
    return `/api/lighthouse?${parts.join("&")}`;
  },
  lighthouseById: (id) => `/api/lighthouse/${encodeURIComponent(id)}`,
  lighthouseRaw: (id) => `/api/lighthouse/${encodeURIComponent(id)}/raw`,

  agileArtifactsCreate: () => `/api/agile-artifacts`,
  agileArtifactsUpdate: id => `/api/agile-artifacts/${id}`,

  workFlowCreate: () => `/api/workflows`,
  workFlowUpdate: id => `/api/workflows/${id}`,

  api_col_update: id => `/api/${id}/updateColumn`
};
